export class AdminData  {

  constructor(
      public id?: number,
      public user?: string,
      public role?: string,
      public name?: string,
      public lastname?: string,
      public created_at?: string,
      public updated_at?: string,
      public permission?: string[],
      public menu_permissions: any[] = [],
      public allowed_menu_ids: number[] = [],
  ) {}

  public isLogged() {
      return !!this.id;
  }

  public setData(data: any) {
      this.id = data?.id;
      this.user = data?.user;
      this.role = data?.role;
      this.name = data?.name;
      this.lastname = data?.lastname;
      this.created_at = data?.created_at;
      this.updated_at = data?.updated_at;

        this.permission = Array.isArray(data?.permission) ? data.permission : [];
        this.menu_permissions = Array.isArray(data?.menu_permissions) ? data.menu_permissions : [];
     this.allowed_menu_ids = Array.isArray(data?.allowed_menu_ids) ? data.allowed_menu_ids : [];
  }
}